import { render, staticRenderFns } from "./StrukA4.vue?vue&type=template&id=3998723a&scoped=true&"
import script from "./StrukA4.vue?vue&type=script&lang=js&"
export * from "./StrukA4.vue?vue&type=script&lang=js&"
import style0 from "./StrukA4.vue?vue&type=style&index=0&id=3998723a&lang=scss&scoped=true&"
import style1 from "./StrukA4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998723a",
  null
  
)

export default component.exports